import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { cleanupData, switchMainTab } from "../../../../../actions/insightsRecommendationActions";
// import { toast } from "react-toastify";
// import Icon from "semantic-ui-react/dist/es/elements/Icon";

const InsightsTabComponent = () => {
    const dispatch = useDispatch();
    // const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const currentActiveQuestion = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    const handleClick = (chart) => {
        dispatch(cleanupData());

        if (currentActiveQuestion === chart) dispatch(switchMainTab("home"));
        else dispatch(switchMainTab(chart));
        // if (currentActiveQuestion === chart) return;
        // dispatch(cleanupData());
        // dispatch(switchMainTab(chart));
    };

    return (
        <div className="insights__tab__comtainer">
            {QuestionLists.map((obj) => (
                <div
                    key={obj.questionTab}
                    className={`block ${obj.questionTab === currentActiveQuestion ? "active__question" : ""}`}
                    onClick={() => handleClick(obj.questionTab)}>
                    {/* <Icon name="arrow alternate circle left outline" /> */}
                    {obj.question}
                </div>
            ))}
        </div>
    );
};

export default InsightsTabComponent;
export const QuestionLists = [
    {
        question: " How did my brand perform last week?",
        questionTab: "overall-summary",
    },
    {
        question: "Which platforms were impactful for my brand?",
        questionTab: "platform-summary",
    },
    {
        question: "How did my brand perform relative to my competitors?",
        questionTab: "brand-comparision",
    },
    {
        question: "Who were the top influencers?",
        questionTab: "dynamic",
    },
    {
        question: "Which keywords were most impactful for my brand?",
        questionTab: "ocr",
    },
    {
        question: "What are the top emerging topics?",
        questionTab: "top-topics",
    },
    {
        question: "What were the top attributes detected in conversations I am tracking?",
        questionTab: "product-attributes",
    },
];
